module.exports = __webpack_public_path__ + "static/media/cellphone.1a0fe3e3.svg";